/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
// import { Module } from '@msdyn365-commerce-modules/utilities';
import { Module } from '@msdyn365-commerce-modules/utilities';

import * as React from 'react';
import { IAccountWelcomeTileViewProps } from '@msdyn365-commerce-modules/account-management/dist/types/modules/account-welcome-tile/account-welcome-tile';
import { IAccountWelcomeTileProps as IAccountWelcomeTileExtendedProps } from '../definition-extensions/account-welcome-tile.ext.props.autogenerated';
const AccountWelcomeTileView: React.FC<IAccountWelcomeTileViewProps & IAccountWelcomeTileExtendedProps<{}>> = props => {
    const {
        AccountWelcomeTile,
        heading,
        context: {
            request: { user }
        },
        config: { signOutLinkText }
    } = props;

    return (
        <Module {...AccountWelcomeTile}>
            <div className='col-7 col-md-6'>{heading}</div>
            <div className='col-5 col-md-6 account-signout-wrap'>
                {signOutLinkText && <a href={(user && user.signOutUrl) || ''}>{signOutLinkText}</a>}
            </div>
        </Module>
    );
};

export default AccountWelcomeTileView;
